import * as React from 'react';

import {
  humanReadableNumber,
  humanReadableShortPricingUnit,
} from '@rematter/ui-web';

import { SalesOrderRecord } from '../../types/salesOrder';
import { convertWeightToDisplayValue } from '../../utils/weight';

import { CommonCellProps } from './hooks/useSalesOrdersListColumns';

import { getLocale } from '~/shared/utils/locale';

export type NetWeightCellProps = {
  row: SalesOrderRecord;
  commonCellProps?: (salesOrder: SalesOrderRecord) => CommonCellProps;
};

const formatNetWeight = (
  totalNetWeight: SalesOrderRecord['totalNetWeight'],
) => {
  if (!totalNetWeight) return undefined;

  const displayValue = convertWeightToDisplayValue(
    totalNetWeight,
    totalNetWeight.unit,
  );

  return `${displayValue} ${humanReadableShortPricingUnit(totalNetWeight.unit)}`;
};

const formatNetEach = (totalEachCount: SalesOrderRecord['totalEachCount']) => {
  if (!totalEachCount) return undefined;

  return `${humanReadableNumber(totalEachCount, { locale: getLocale() })} ${humanReadableShortPricingUnit('Each')}`;
};

export const NetWeightCell = ({ row, commonCellProps }: NetWeightCellProps) => {
  const netWeight = React.useMemo(
    () => formatNetWeight(row.totalNetWeight),
    [row.totalNetWeight],
  );

  const netEach = React.useMemo(
    () => formatNetEach(row.totalEachCount),
    [row.totalEachCount],
  );

  const content = React.useMemo(() => {
    if (netWeight && netEach) return `${netWeight} • ${netEach}`;
    if (netWeight) return netWeight;
    if (netEach) return netEach;
    return '-';
  }, [netEach, netWeight]);

  return (
    <div
      {...(commonCellProps ? commonCellProps(row) : undefined)}
      className="@NetWeightCell text-right"
    >
      {content}
    </div>
  );
};
